export default __webpack_public_path__ + "static/media/Smart-Governance-OFF.18cd43dc.svg";